// Firmware
export const nullIfEmpty = {
  setValueAs<T>(value: T): Exclude<T, ''> | null {
    // Use setvalue for null!
    if (value === '') return null;
    return value as Exclude<T, ''>;
  },
};
